import { apiClient } from '../utils/apiClient';

export type ExportFormat = 'pdf' | 'docx' | 'md';

/**
 * Exporte un dossier dans le format spécifié et déclenche le téléchargement
 */
export const exportDossier = async (
    dossierId: string,
    format: ExportFormat
): Promise<boolean> => {
    try {
        const response = await apiClient(
            `/dossiers/${dossierId}/export?format=${format}`
        );

        if (!response.ok) {
            console.error('Export failed:', response.status);
            return false;
        }

        const blob = await response.blob();

        // Extraire le nom de fichier du header Content-Disposition
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `dossier.${format}`;
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (match?.[1]) {
                filename = match[1];
            }
        }

        // Déclencher le téléchargement
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
    } catch (error) {
        console.error('Export error:', error);
        return false;
    }
};
